// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicOfferBusinessEntityAcceptRequest,
  TPublicOfferBusinessEntityAcceptModel,
  IMappers,
  TPublicOfferBusinessEntityAcceptResponse,
  IPublicOfferBusinessEntityAcceptResponseError,
} from './types';

export const defaultConfig: TPublicOfferBusinessEntityAcceptModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'dailyrent',
  pathApi: '/v1/public-offer/business-entity/accept/',
  requestType: 'json',
} as TPublicOfferBusinessEntityAcceptModel;

export function createPublicOfferBusinessEntityAcceptModel(
  parameters: IPublicOfferBusinessEntityAcceptRequest,
): TPublicOfferBusinessEntityAcceptModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicOfferBusinessEntityAcceptOptions<TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400>;
  parameters: IPublicOfferBusinessEntityAcceptRequest;
}

export async function fetchPublicOfferBusinessEntityAccept<TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicOfferBusinessEntityAcceptOptions<TResponse400>): Promise<
  TPublicOfferBusinessEntityAcceptResponse | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicOfferBusinessEntityAcceptModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IPublicOfferBusinessEntityAcceptResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicOfferBusinessEntityAcceptResponse;
}
